import React, { Component } from 'react'
import OneLineEditor from './OneLineEditor'

class KingakuEditor extends Component {
  constructor (props) {
    super(props)
    this.state = {
      bindingDataAttribute: this.props.bindingDataAttribute
    }
  }
  render () {
    return (
      <div>
        <OneLineEditor bindingDataAttribute={this.state.bindingDataAttribute}
          textAlign='right' prefix='¥' isCommaSeparated />
      </div>
    )
  }
}

export default KingakuEditor



// WEBPACK FOOTER //
// ./src/company_user/components/KingakuEditor.js